import { render } from "./Sound.vue?vue&type=template&id=7b8d1211&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7b8d1211"

export default script